import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError as _throw } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';

import { ErrorService } from '../../account-setup/services/error.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private toastr: ToastrService, private router: Router, private errorService: ErrorService) {}

  ShowException: void;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const timeoutValue = Number(req.headers.get('timeout')) || 30000;
    return next.handle(req).pipe(
      timeout(timeoutValue),
      catchError(response => {
        if (response.name === 'TimeoutError') {
          this.toastr.error(response.message);
        } else if (response.name === 'HttpErrorResponse' && response.status === 0) {
          this.toastr.error(response.message);
        } else {
          switch (response.status) {
            case 400:
            case 404:
            case 500: {
              this.errorService.SetErrorData(response);
              this.router.navigate([`/error`]);
              break;
            }
            case 401: {
              location.href = '/RRDCommon/SignOut.aspx';
              break;
            }
            default: {
              this.toastr.error(response.error.Message);
              break;
            }
          }
        }
        return _throw(response);
      })
    );
  }
}

export const ErrorInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: ErrorInterceptor,
  multi: true
};
